/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_LabelInputs */



/**
* | output |
* | --- |
* | "Select a preset to load" |
*
* @param {Audio_Description_Export_Preset_Load_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_label = /** @type {((inputs?: Audio_Description_Export_Preset_Load_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un préréglage à charger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Voreinstellung zum Laden aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un preset da caricare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановку для загрузки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un ajuste preestablecido para cargar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要加载的预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み込むプリセットを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लोड करने के लिए एक प्रीसेट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma predefinição para carregar.")
	return /** @type {LocalizedString} */ ("Select a preset to load")
});